const objeto4 = {
  titulo: `Objetos: Arreglos con componentes de tipo objeto`,
  problemas: [
    {
      codigo: 1,
      descripcion: `Es muy común que un arreglo contenga componentes de tipo objeto. Por ejemplo, un arreglo de personas:
<pre>
const personas = [
    {
      nombre: 'Juan',
      apellido: 'Perez',
      edad: 20
    },{
      nombre: 'Pedro',
      apellido: 'Perez',
      edad: 35
    },{
      nombre: 'Maria',
      apellido: 'Perez',
      edad: 10
    }
]
</pre>              
Como vemos en estos casos cada objeto no tiene un nombre, sino se almacena en el arreglo y se lo accede por su índice.

<code>
console.log(personas[0]) // {nombre: 'Juan', apellido: 'Perez', edad: 20}
console.log(personas[1]) // {nombre: 'Pedro', apellido: 'Perez', edad: 35}
console.log(personas[0].nombre) // 'Juan'
</code>`,
      programa: `const personas = [
    {
        nombre: 'Juan',
        apellido: 'Perez',
        edad: 20
    }, {
        nombre: 'Pedro',
        apellido: 'Perez',
        edad: 30
    }, {
        nombre: 'Maria',
        apellido: 'Perez',
        edad: 40
    }
]
          
let suma = 0
for (let persona of personas) {
  suma += persona.edad
}
let promedio = suma / personas.length
console.log(promedio)`,
      solucion: "30"
    }, {
      codigo: 2,
      descripcion: `En el problema anterior en lugar de utilizar un for of podemos emplear un for clásico:
<code>
let suma = 0
for (let i = 0; i < personas.length; i++) {
  suma += personas[i].edad
}
let promedio = suma / personas.length
console.log(promedio)
</code>
En el ejemplo siguiente queremos contar la cantidad de empleados que hablan 3 idiomas:`,
      programa: `const empleados = [
    {
        nombre: "Diego",
        apellido: "Garcia",
        edad: 45,
        idiomas: ["Español", "Ingles", "Frances"],
        trabajo: {
                    empresa: "Google",
                    fechaingreso: "01/01/2020",
                    salarios: [5000, 5000, 5000]
                }
    },
    {
        nombre: "Juan",
        apellido: "Perez",
        edad: 30,
        idiomas: ["Español"],
        trabajo: {
                    empresa: "Facebook",
                    fechaingreso: "01/01/2020",
                    salarios: [1000, 2000, 3000]
                  }
    },
    {
        nombre: "Pedro",
        apellido: "Martinez",
        edad: 25,
        idiomas: ["Español", "Portugues", "Chino"],
        trabajo: {
                    empresa: "Twitter",
                    fechaingreso: "01/01/2020",
                    salarios: [3000, 2000, 2000]
                  }
    },
    {
        nombre: "Maria",
        apellido: "Gonzalez",
        edad: 35,
        idiomas: ["Español", "Ingles", "Chino"],
        trabajo: {
                    empresa: "Instagram",
                    fechaingreso: "01/01/2020",
                    salarios: [3000, 4000, 4000]
                 }
    }
]
          
let cantidad = 0
for (empleado of empleados) {
  if (empleado.idiomas.length == 3) {
    cantidad++
  }
}
console.log(cantidad)`,
      solucion: "3"
    }, {
      codigo: 3,
      descripcion: `Queremos ahora calcular el promedio de vida de las mujeres teniendo en cuenta los 4 paises:`,
      programa: `const paises = [
  {
    nombre: "Argentina",
    capital: "Buenos Aires",
    poblacion: 4000000,
      moneda: "Peso Argentino",
      idioma: "Español",
      agricultura: ["trigo", "maiz", "soja"],
      expectativavida: {
        hombres: 75,
        mujeres: 78
      }
    },
    {
      nombre: "Brasil",
      capital: "Brasilia",
      poblacion: 20000000,
      moneda: "Real",
      idioma: "Portugues",
      agricultura: ["trigo", "cebada"],
      expectativavida: {
        hombres: 74,
        mujeres: 80
      }
    },
    {
      nombre: "Uruguay",
      capital: "Montevideo",
      poblacion: 3000000,
      moneda: "Peso Uruguayo",
      idioma: "Español",
      agricultura: ["soja"],
      expectativavida: {
        hombres: 81,
        mujeres: 80
      }
    },
    {
      nombre: "Chile",
      capital: "Santiago",
      poblacion: 16000000,
      moneda: "Peso Chileno",
      idioma: "Español",
      agricultura: ["maiz", "cebada"],
      expectativavida: {
        hombres: 80,
        mujeres: 82
      }
    }
  ]

let promedioMujer = 0;
for (let i = 0; i < paises.length; i++) {
  promedioMujer += paises[i].expectativavida.mujeres
}
promedioMujer = promedioMujer / paises.length
console.log(promedioMujer)`,
solucion: "80"
    }, {
      codigo: 4,
      descripcion: `Generar un arreglo con los apellidos de deportistas que han ganado una o mas medallas de oro:`,
      programa: `const deportistas = [
  {
    nombre: "Juan",
    apellido: "Perez",
    edad: 20,
    deporte: "Pesas",
    medallas: [
      {
        tipo: "oro",
        cantidad: 2
      },
      {
        tipo: "bronce",
        cantidad: 1
      }
    ]
  },
  {
    nombre: "Pedro",
    apellido: "Gonzalez",
    edad: 25,
    deporte: "Futbol",
    medallas: [
      {
        tipo: "oro",
        cantidad: 1
      },
      {
        tipo: "plata",
        cantidad: 3
      },
      {
        tipo: "bronce",
        cantidad: 3
      }
    ]
  },
  {
    nombre: "Maria",
    apellido: "Lopez",
    edad: 22,
    deporte: "Tenis",
    medallas: []
  },
  {
    nombre: "Ana",
    apellido: "Martinez",
    edad: 21,
    deporte: "Natacion",
    medallas: [
      {
        tipo: "plata",
        cantidad: 1
      }
    ]
  },
  {
    nombre: "Marta",
    apellido: "Gomez",
    edad: 20,
    deporte: "Natacion",
    medallas: [
      {
        tipo: "plata",
        cantidad: 1
      },
      {
        tipo: "bronce",
        cantidad: 1
      }
    ]
  }
]

const deportistasOro = []
for (let deportista of deportistas) {
  for (let medalla of deportista.medallas) {
    if (medalla.tipo == "oro") {
      deportistasOro.push(deportista.apellido)
    }
  }
}
console.log(deportistasOro)`,
solucion: "['Perez', 'Gonzalez']"
    }
  ]
}

export default objeto4;